import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { CoreReviewPageRendererBaseComponent } from '../shared/core-review-page-renderer-base.component';
import { PageElementBaseComponent } from '../shared/page-element-base.component';
import { PageResolveHelper } from './page-resolver.helper';

/**
 * The component responsible to resolve and render the building block
 */
@Component({
  selector: 'cu-review-page-renderer-resolver',
  template: `<ng-container #reviewPageContainer></ng-container>`,
  standalone: false
})
export class ReviewPageRendererResolverComponent extends PageElementBaseComponent implements OnInit {
  /**
   * Reference to  controlContainer where building block is rendered
   */
  @ViewChild('reviewPageContainer', { static: true, read: ViewContainerRef })
  public pageContainer: ViewContainerRef;

  constructor(private readonly componentFactoryResolver: ComponentFactoryResolver) {
    super();
  }

  public ngOnInit(): void {
    const component = new PageResolveHelper(
      this.componentFactoryResolver,
      this.pageContainer,
      this.page,
      this.flow
    ).resolve<CoreReviewPageRendererBaseComponent>(this.page.helper.reviewRendererType);

    component.instance.page = this.page;
    component.instance.flow = this.flow;
  }
}
